module.exports = __webpack_public_path__ + "img/figure_4.f004a787.svg";